export const TAX_STATUSES_REDUCER_NAME = 'tax-statuses';

export const taxStatusesReducer = (state = {}) => state;

export const getTaxStatuses = (state) => state[TAX_STATUSES_REDUCER_NAME];
